import { render, staticRenderFns } from "./ParcoursCpge.vue?vue&type=template&id=2db24630&scoped=true"
import script from "./ParcoursCpge.vue?vue&type=script&lang=js"
export * from "./ParcoursCpge.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/DemandeBourse.css?vue&type=style&index=0&id=2db24630&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db24630",
  null
  
)

export default component.exports